import BackgroundLogin from "../assets/back-login.jpg";
import {makeStyles} from "@material-ui/core/styles";

export const homePageStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        backgroundColor: "#000",
    },
    image: {
        backgroundImage: `url(${BackgroundLogin})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor: "#000",
        backgroundSize: 'cover',
        opacity: 0.4,
    },
    paper: {
        margin: theme.spacing(8, 4),
        paddingLeft: 0,
        paddingRight: 0,
        [theme.breakpoints.only('xl')]: {
            paddingLeft: 100,
            paddingRight: 100,
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: 40,
    },

    /** CUSTOMIZAÇÃO DO TEXTFIELD */
    textField: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'transparent',
            borderRadius: 4,
            color: '#fff',
            '& fieldset': {
                borderColor: '#888', // borda simples
            },
            '&:hover fieldset': {
                borderColor: '#aaa',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#b1b1b1', // borda ao focar
            },
        },
        '& .MuiInputLabel-root': {
            color: '#ccc', // label padrão
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#fff', // label ao focar
        },
        '& .MuiInputBase-input': {
            color: '#fff', // cor do texto digitado
        },
        '& .MuiInputLabel-shrink': {
            color: '#ccc',
        },
        '& .MuiOutlinedInput-root input:-webkit-autofill': {
            boxShadow: '0 0 0 1000px transparent inset',
            WebkitTextFillColor: '#fff',
            transition: 'background-color 5000s ease-in-out 0s',
        },
        '& .MuiOutlinedInput-root.Mui-focused input:-webkit-autofill': {
            boxShadow: '0 0 0 1000px transparent inset',
            WebkitTextFillColor: '#fff',
        }
    },
    select: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'transparent',
        borderRadius: 4,
        color: '#000',
        '& fieldset': {
          borderColor: '#888',
        },
        '&:hover fieldset': {
          borderColor: '#aaa',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#b1b1b1',
        },
      },
      '& .MuiInputLabel-root': {
        color: '#ccc',
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: '#b1b1b1',
      },
      '& .MuiInputBase-input': {
        color: '#fff',
      },
      '& .MuiSelect-select': {
        color: '#fff',
        backgroundColor: 'transparent',
      },
      '& .MuiSelect-icon': {
        color: '#ccc',
      },
      '& .MuiSelect-icon.Mui-focused': {
        color: '#b1b1b1',
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent',
      },
    }
}))